import { Span } from "../../components/Text/Text";
import { VersionT } from "../../models/models";
import { VideoContentStatusE } from "../../models/enums";
import VideoPlayer from "../../popups/VideoPlayer/VideoPlayer";
import { useTranslate } from "../../utils/hooks/useTranslate";
import styles from "./styles.module.scss";
import Button from "../../components/Button/Button";
import usePopup from "../../utils/hooks/usePopup";
import VideoPlayerCustom from "../../popups/VideoPlayerCustom/VideoPlayerCustom";

const videoPlayerItem = {
  Name: "Test Video",
  Description: "This is a test video",
  DesktopPlaybackUrl: 'https://www.youtube.com/embed/22izxhm315c?si=MR5Sh8lhvzAu4GnU',
  DesktopVideoHeight: 0,
  DesktopVideoWidth: 0,
  Id: 0,
  PreviewDownloadUrl: null,
  fileFormat: "mp4",
  AdId: "",
  ProjectId: 0,
  ProjectType: 0,
  StatusName: VideoContentStatusE.UPLOADED,
  ThumbnailUrlTemplate: null,
  UploadAllowed: true,
  UploadDateTime: null,
  UploadErrorDescription: null,
  VideoHeight: 0,
  VideoWidth: 0,
  WideScreen: false,
  isChannel5or9: false,
  sponsershipHouseNumber: "",
  useFor2Spots: false,
  EncodingErrorDescription: null,
  Status: 0,
  IsReactProject: false,
  ActualFrameCount: null,
  ActualLength: null,
  DownloadAllowed: false,
  FTPSendAllowed: false,
  FileType: 0,
  SecondHouseNumberType: 0,
  FileSize: 0,
  FilePath: "",
  EncodedFileId: 0,
  EncodedFileAssets: null,
  HouseNumber: "",
  MobilePlaybackUrl: null,
  MobileVideoHeight: 0,
  MobileVideoWidth: 0,
  EncodingCompleteDateTime: null,
  NotSuitableForBroadcast: false,
  NotSuitableForBroadcastComment: "",
  NotSuitableForBroadcastReason: 0,
  NotSuitableForBroadcastType: 0,
  RequiredLength: 0,
  ShareAllowed: false,
} as VersionT;

const Test = () => {
  const { t } = useTranslate();
  const { createPopup } = usePopup();
  
  const openPopup = () => {
    createPopup({
      body: <VideoPlayerCustom item={videoPlayerItem} />,
    });
  };

  return (
    <div className={styles.wrapper}>
      <Button onClick={openPopup}>Open popup</Button>
    </div>
  );
};

export default Test;
